import { Flex, IconButton, Select, Text } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

export interface ListPaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  pageSize?: number;
  pageSizeOptions?: number[];
  onPageSizeChange?: (size: number) => void;
}

export const ListPagination = ({
  page, totalPages, onPageChange,
  pageSize, pageSizeOptions, onPageSizeChange,
}: ListPaginationProps) => {
  const hasPagination = totalPages > 1;
  const hasPageSizeSelector = Boolean(onPageSizeChange && pageSizeOptions && pageSizeOptions.length > 0);
  if (!hasPagination && !hasPageSizeSelector) return null;
  return (
    <Flex align="center" justify="flex-end" gap={2} mt={4} flexWrap="wrap">
      {hasPagination && (
        <>
          <IconButton
            aria-label="Página anterior"
            icon={<ChevronLeftIcon boxSize={3} />}
            size="xs" variant="outline" borderRadius="md"
            isDisabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
          />
          <Text fontSize="xs" color="gray.500" minW="80px" textAlign="center">
            Página {page} de {totalPages}
          </Text>
          <IconButton
            aria-label="Próxima página"
            icon={<ChevronRightIcon boxSize={3} />}
            size="xs" variant="outline" borderRadius="md"
            isDisabled={page >= totalPages}
            onClick={() => onPageChange(page + 1)}
          />
        </>
      )}
      {hasPageSizeSelector && (
        <Flex align="center" gap={1} ml={1}>
          <Text fontSize="xs" color="gray.500" whiteSpace="nowrap">por página</Text>
          <Select
            size="xs" variant="outline" borderRadius="md" w="64px"
            value={pageSize}
            onChange={(e) => onPageSizeChange!(Number(e.target.value))}
          >
            {pageSizeOptions!.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </Select>
        </Flex>
      )}
    </Flex>
  );
};